import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Réserve la route aux ROLE_MANAGER (ROLE_ADMIN l'inclut via la hiérarchie back).
 * À chaîner APRÈS authGuard sur la route. Le back reste l'autorité (403 sinon).
 */
export const managerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isManager() ? true : router.createUrlTree(['/']);
};
